<template>
    <div class="white-box md:rounded-t-lg md:mt-5 min-h-[50vh] pt-2.5 md:pt-5">
        <Title
            class="my-0"
            :text="$route.meta.pageTitle"
            style-code-page
        />
        <ul class="text-tip mt-3 mb-4">
            <li>
                以下為您於111/08/12後，於新版線上交易申請之申請紀錄。點選右方按鈕可下載PDF檔，查詢申請內容，密碼為您登入時之要保人身份證字號(英文字母為大寫)。
            </li>
        </ul>
        <div class="border-b " />
        <h4 class="mt-3.5 mb-2">
            請選擇查詢年份
        </h4>
        <div class="mb-2.5 flex items-center justify-between">
            <div class="w-[11.375rem]">
                <Multiselect
                    v-model="year"
                    class="select-base h-12"
                    :options="yearArray"
                    :can-clear="false"
                    :can-deselect="false"
                />
            </div>
            <p class="text-lg text-gray-700">
                共{{ total }}筆
            </p>
        </div>

        <Table>
            <template #thead>
                <tr class="text-sm xs:text-base">
                    <td class="w-[6rem] pad:w-[7rem]">
                        申請日期
                    </td>
                    <td class="sm:w-2/5 pad:w-1/4">
                        <p class="hidden sm:block">
                            受理案號
                        </p>
                        <p class="sm:hidden">
                            受理案號/處理階段
                        </p>
                    </td>
                    <td class="hidden pad:table-cell">
                        申請類別
                    </td>
                    <td class="hidden sm:table-cell pad:w-1/4">
                        處理階段
                    </td>
                    <td class="w-[1.375rem]" />
                </tr>
            </template>
            <template #tbody>
                <tr
                    v-for="item in contents"
                    :key="item.regiNo"
                    class=" cursor-default"
                >
                    <td class="align-top sm:align-middle leading-6 xs:leading-7">
                        <span class="text-sm sm:text-base pad:text-lg">{{ item.transDate }}</span>
                    </td>
                    <td class="break-all text-base xs:text-lg">
                        {{ item.regiNo }}
                        <p class="pad:hidden">
                            {{ item.aplCatl }}
                        </p>
                        <p class="text-base sm:hidden text-gray-900 font-bold">
                            {{ item.statusDesc }}
                        </p>
                        <button
                            v-if="item.canReSendLinkPay"
                            class="btn-text text-primary border-b border-primary text-[1rem] mt-1.5 sm:hidden"
                            @click="doReSendLinkPay(item.regiNo)"
                        >
                            補發繳費授權連結
                        </button>
                    </td>
                    <td class="hidden pad:table-cell">
                        <p class="text-base pad:text-lg">
                            {{ item.aplCatl }}
                        </p>
                    </td>
                    <td
                        class="text-base text-gray-900 hidden sm:table-cell"
                        :class="{'sm:min-w-[9rem]':item.canReSendLinkPay}"
                    >
                        <p>{{ item.statusDesc }}</p>
                        <button
                            v-if="item.canReSendLinkPay"
                            class="btn-text text-primary border-b border-primary text-[1rem] hidden sm:inline mt-2"
                            @click="doReSendLinkPay(item.regiNo)"
                        >
                            補發繳費授權連結
                        </button>
                    </td>
                    <td class="align-top sm:align-middle">
                        <SvgIcon
                            icon-name="file"
                            class="w-6 h-6 cursor-pointer"
                            @click="exportPdf(item.regiNo)"
                        />
                    </td>
                </tr>
            </template>
        </Table>
        <noData
            v-if="contents?.length === 0"
            class="max-w-[24.375rem] pad:max-w-full mx-auto mt-2"
        >
            您此年度沒有任何變更記錄
        </noData>
        <div
            v-else
            class="pagination flex item-center mx-auto mt-5 text-gray-700"
        >
            <div class="mr-2.5">
                <SvgIcon
                    icon-name="expand_more"
                    class="w-6 h-6 rotate-90 "
                    :class="[!isDisable(1)?'cursor-pointer hover:text-green-600' : 'text-gray-100']"
                    @click="prevPage"
                />
            </div>
            <div
                v-for="(num,idx) in pageArr"
                :key="idx"
                class="text-center mr-2.5"
                :class="{'active': currenPage === num,'w-6 h-6':pageArr.length<100,'cursor-pointer hover:text-green-600':!isNaN(Number(num))}"
                @click="goPage(num)"
            >
                {{ num }}
            </div>
            <div>
                <SvgIcon
                    icon-name="expand_more"
                    class="w-6 h-6 -rotate-90"
                    :class="[!isDisable(totalPage)?'cursor-pointer hover:text-green-600' : 'text-gray-100']"
                    @click="nextPage"
                />
            </div>
        </div>
        <Loading :is-loading="isLoading" />
        <Popup
            v-model:visiblePopup="visiblePopup"
            :params="{
                cancelButton: null,
                confirmButton: '確定',
            }"
            @confirm="closePopup"
        >
            <template #title>
                {{ resendLinkPayMessage.title }}
            </template>
            <template #content>
                {{ resendLinkPayMessage.content }}
            </template>
        </Popup>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { getRecord, getPdfRecordToken, reSendLinkPay } from '@/apis/record.js';
import Popup from '@/components/dialogs/Popup.vue';
import moment from 'moment';
import Title from '@/components/text/Title.vue';
import Table from '@/components/table/Table.vue';
import Multiselect from '@vueform/multiselect';
import Loading from '@/components/Loading.vue';
import noData from '@/components/text/EmptyData.vue';

export default {
    components: {
        Title,
        Table,
        Multiselect,
        Loading,
        noData,
        Popup
    },
    setup() {
        const isLoading = ref(false);
        const contents = ref(null);
        const total = ref(0);
        const currenPage = ref(1);
        const year = ref(new Date().getFullYear() - 1911);
        const visiblePopup = ref(false);
        const resendLinkPayMessage = ref({});
        const totalPage = computed(() => {
            return Math.ceil(total.value / 10);
        });
        const yearArray = computed(() => {
            const arr = [];
            const now = moment();
            const mingGuo = now.subtract(1911, 'year').get('year');
            for (let i = mingGuo; i > 110; i--) {
                arr.push(i);
            }
            return arr;
        });

        const getData = () => {
            isLoading.value = true;
            const returnData = {};
            // 後端從第0頁開始
            returnData.page = currenPage.value - 1;
            returnData.size = 10;
            returnData.all = false;
            returnData.year = year.value;
            getRecord(returnData).then(res => {
                if (res.data) {
                    contents.value = res.data.pageable.contents;
                    total.value = res.data.pageable.total;
                    // 後端從第0頁開始，回來頁數要+1
                    currenPage.value = res.data.pageable.page + 1;
                }
            }).finally(() => {
                isLoading.value = false;
            });
        };
        getData();

        const pageArr = computed(() => {
            const arr = [];
            // 如果總頁數小於8,直接全部呈現1~7頁
            if (totalPage.value < 8) {
                for (let i = 1; i <= totalPage.value; i++) {
                    arr.push(i);
                }
            } else {
                if (currenPage.value < 5) {
                    // 如果頁數小於5,呈現1~5頁後加...與總頁數
                    for (let i = 1; i <= totalPage.value; i++) {
                        if (arr.length === 5) {
                            arr.push('...');
                            arr.push(totalPage.value);
                            break;
                        }
                        arr.push(i);
                    }
                } else if (currenPage.value >= 5 && currenPage.value < totalPage.value - 3) {
                    // 如果頁數大於5,小於總頁數-3，呈現1加...後，加上頁數-1、頁數、頁數+1，前面共5個按鈕，再加...與總頁數
                    arr.push(1);
                    arr.push('...');
                    for (let i = currenPage.value - 1; i <= totalPage.value; i++) {
                        if (arr.length === 5) {
                            arr.push('...');
                            arr.push(totalPage.value);
                            break;
                        }
                        arr.push(i);
                    }
                } else {
                    // 如果頁數大於總頁數-3，呈現1加...後，再加上總頁數-4~總頁數共5個按鈕
                    arr.push(1);
                    arr.push('...');
                    for (let i = totalPage.value - 4; i <= totalPage.value; i++) {
                        arr.push(i);
                    }
                }
            }
            return arr;
        });

        const isDisable = computed(() => {
            return (value) => currenPage.value === value ? currenPage.value === value : false;
        });

        const prevPage = () => {
            if (currenPage.value - 1 > 0) currenPage.value--;
        };
        const nextPage = () => {
            if (currenPage.value + 1 <= totalPage.value) currenPage.value++;
        };
        const goPage = (num) => {
            if (isNaN(Number(num)) !== true) currenPage.value = Number(num);
        };

        const doReSendLinkPay = (regiNo) => {
            isLoading.value = true;
            reSendLinkPay(regiNo).then(res => {
                isLoading.value = false;
                visiblePopup.value = true;
                resendLinkPayMessage.value = res.data.resendLinkPayMessage;
            });
        };

        const closePopup = () => {
            visiblePopup.value = false;
            resendLinkPayMessage.value = {};
        };

        const exportPdf = (regiNo) => {
            isLoading.value = true;
            getPdfRecordToken(regiNo).then((response) => {
                const token = response.data.token;
                const baseUrl = `${window.location.origin}/${window.location.pathname.split('/')[1]}`;
                window.open(baseUrl + '/api/transaction/record/downloadPdf?token=' + token, '_blank');
            }).finally(() => {
                setTimeout(() => {
                    isLoading.value = false;
                }, 500);
            });
            // exportPdfRecord(regiNo).then((res) => {
            //     const blob = new Blob(['\ufeff', res], {
            //         type: 'application/pdf;charset=UTF-8',
            //     });
            //     const objectUrl = URL.createObjectURL(blob);
            //     const link = document.createElement('a');
            //     link.href = objectUrl;
            //     link.download = regiNo + '.pdf';
            //     document.body.appendChild(link);
            //     link.click();
            //     URL.revokeObjectURL(objectUrl);
            //     document.body.removeChild(link);
            // }).finally(() => {
            //     isLoading.value = false;
            // });
        };

        watch(year, (nV) => {
            currenPage.value !== 1 ? currenPage.value = 1 : getData();
        });

        watch(currenPage, (nV) => {
            getData();
        });

        return {
            isLoading,
            contents,
            total,
            totalPage,
            currenPage,
            pageArr,
            year,
            isDisable,
            yearArray,
            visiblePopup,
            resendLinkPayMessage,
            exportPdf,
            nextPage,
            prevPage,
            goPage,
            getData,
            doReSendLinkPay,
            closePopup
        };
    },
};
</script>
<style lang="scss" scoped>
.pagination {
    width: fit-content;
}
.active {
    @apply text-green-600 font-bold;
}
</style>
